import React from 'react';
import { Center } from '@fiverr-private/layout_components';

export const ImportErrorImage = () => (
    <Center width={400} height={220}>
        <svg viewBox="0 0 400 220" fill="none" xmlns="http://www.w3.org/2000/svg" aria-label="Import failed image">
            <g clipPath="url(#clip0_2549_131403)">
                <path
                    d="M193.389 152.842H131.776V219.981H193.389V152.842Z"
                    stroke="#232426"
                    strokeWidth="1.5"
                    strokeMiterlimit="10"
                />
                <path
                    d="M143.624 152.842C143.43 164.503 144.618 174.566 143.624 186.408C142.631 198.25 144.766 213.804 143.624 219.974"
                    stroke="#232426"
                    strokeWidth="1.5"
                    strokeMiterlimit="10"
                />
                <path
                    d="M157.178 153.003C157.178 165.187 155.601 166.221 156.191 178.614C156.782 191.006 156.319 188.952 156.057 198.25C155.795 207.548 155.93 210.3 156.057 213.059C156.185 215.818 155.909 219.974 155.909 219.974"
                    stroke="#232426"
                    strokeWidth="1.5"
                    strokeMiterlimit="10"
                />
                <path
                    d="M170.162 153.003C169.766 157.608 168.98 153.567 168.779 168.678C168.577 183.79 168.584 191.436 168.779 194.323C168.973 197.209 169.229 199.968 169.396 206.856C169.564 213.744 168.879 219.974 168.631 219.974"
                    stroke="#232426"
                    strokeWidth="1.5"
                    strokeMiterlimit="10"
                />
                <path
                    d="M183.44 153.003C183.051 159.676 182.85 165.872 182.259 173.109C181.668 180.346 182.259 185.864 182.259 191.705C182.259 197.545 181.051 206.171 181.064 210.649C181.077 215.127 181.064 219.974 181.064 219.974"
                    stroke="#232426"
                    strokeWidth="1.5"
                    strokeMiterlimit="10"
                />
                <path d="M66.2076 219.98H346.094" stroke="#232426" strokeWidth="1.5" strokeLinejoin="bevel" />
                <path
                    d="M98.9949 219.658C117.103 219.658 131.782 204.979 131.782 186.871C131.782 168.763 117.103 154.083 98.9949 154.083C80.887 154.083 66.2076 168.763 66.2076 186.871C66.2076 204.979 80.887 219.658 98.9949 219.658Z"
                    stroke="#232426"
                    strokeWidth="1.5"
                    strokeMiterlimit="10"
                />
                <path
                    d="M128.627 200.902C124.857 208.68 118.168 214.656 110.015 217.527C101.861 220.399 92.9039 219.935 85.0912 216.236C77.2785 212.536 71.2428 205.901 68.2973 197.775C65.3517 189.648 65.7348 180.686 69.3631 172.84"
                    fill="#232426"
                />
                <path
                    d="M128.627 200.902C124.857 208.68 118.168 214.656 110.015 217.527C101.861 220.399 92.9039 219.935 85.0912 216.236C77.2785 212.536 71.2428 205.901 68.2973 197.775C65.3517 189.648 65.7348 180.686 69.3631 172.84"
                    stroke="#232426"
                    strokeWidth="1.5"
                    strokeMiterlimit="10"
                />
                <path
                    d="M87.7304 133.071L73.6125 166.12L98.9951 138.979L110.038 155.997L107.239 135.139L136.213 152.841L115.516 122.129L131.776 105.574L102.513 116.08L102.808 93.1611L92.1611 113.777L71.7664 102.029L84.7765 122.424L63.1936 136.025L87.7304 133.071Z"
                    stroke="#232426"
                    strokeWidth="1.5"
                    strokeLinejoin="bevel"
                />
                <path
                    d="M300.941 119.601L274.42 130.516L311.056 219.533L337.576 208.618L300.941 119.601Z"
                    stroke="#232426"
                    strokeWidth="1.5"
                    strokeMiterlimit="10"
                />
                <path
                    d="M296.303 80.104L273.84 70.1147L243.537 56.5474L227.351 68.9936L240.617 79.9429L228.217 85.2664L237.918 94.9402L218.409 98.8607L228.211 115.644L216.61 116.322L220.276 123.612L246.746 135.387L267.577 144.658L296.303 80.104Z"
                    stroke="#232426"
                    strokeWidth="1.5"
                    strokeMiterlimit="10"
                />
                <path
                    d="M190.63 110.045L199.264 92.1142L185.703 94.0275L188.919 80.9233L172.189 84.9042L172.015 64.4961L149.384 77.0901L124.445 90.879L158.642 152.708L185.119 138.066L211.508 123.472L203.479 122.008L209.938 112.341L190.63 110.045Z"
                    stroke="#232426"
                    strokeWidth="1.5"
                    strokeMiterlimit="10"
                />
                <path
                    d="M237.334 61.3137L293.53 86.3204L296.303 80.104L243.537 56.5474L237.334 61.3137Z"
                    fill="#B1ABFF"
                    stroke="#B1ABFF"
                    strokeWidth="1.5"
                    strokeMiterlimit="10"
                />
                <path d="M127.741 96.8334L172.082 72.3101" stroke="#232426" strokeWidth="1.5" strokeMiterlimit="10" />
                <path
                    d="M127.741 96.8336L172.082 72.3103L172.015 64.4961L124.445 90.879L127.741 96.8336Z"
                    fill="#B1ABFF"
                    stroke="#B1ABFF"
                    strokeWidth="1.5"
                    strokeMiterlimit="10"
                />
                <path
                    d="M129.694 93.2685C130.492 93.2685 131.138 92.6223 131.138 91.8252C131.138 91.028 130.492 90.3818 129.694 90.3818C128.897 90.3818 128.251 91.028 128.251 91.8252C128.251 92.6223 128.897 93.2685 129.694 93.2685Z"
                    fill="white"
                />
                <path
                    d="M134.3 90.7177C135.097 90.7177 135.743 90.0715 135.743 89.2744C135.743 88.4773 135.097 87.8311 134.3 87.8311C133.503 87.8311 132.857 88.4773 132.857 89.2744C132.857 90.0715 133.503 90.7177 134.3 90.7177Z"
                    fill="white"
                />
                <path
                    d="M138.912 88.1733C139.709 88.1733 140.355 87.5271 140.355 86.73C140.355 85.9328 139.709 85.2866 138.912 85.2866C138.114 85.2866 137.468 85.9328 137.468 86.73C137.468 87.5271 138.114 88.1733 138.912 88.1733Z"
                    fill="white"
                />
                <path d="M182.407 46.4775L192.544 60.6222" stroke="#232426" strokeWidth="1.5" strokeMiterlimit="10" />
                <path d="M202.888 42V57.6686" stroke="#232426" strokeWidth="1.5" strokeMiterlimit="10" />
                <path d="M222.102 45.249L214.717 57.6684" stroke="#232426" strokeWidth="1.5" strokeMiterlimit="10" />
                <path
                    d="M223.8 160.562C223.8 160.562 221.699 140.758 237.045 136.616C252.392 132.474 264.811 145.188 258.306 160.562C258.306 160.562 283.924 147.303 289.589 167.382C295.255 187.461 277.506 197.222 262.737 192.49C262.737 192.49 273.672 216.724 250.908 219.98C228.144 223.236 227.553 191.013 227.553 191.013C227.553 191.013 198.592 213.522 194.054 184.803C189.207 154.09 213.247 144.275 223.8 160.562Z"
                    fill="#232426"
                    stroke="#232426"
                    strokeWidth="1.5"
                    strokeMiterlimit="10"
                />
            </g>
            <defs>
                <clipPath id="clip0_2549_131403">
                    <rect width="400" height="220" fill="white" />
                </clipPath>
            </defs>
        </svg>
    </Center>
);
